var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubtitles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1691032372900,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3198,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 470.016l0-43.989333q0-18.005333-11.989333-29.994667t-29.994667-11.989333l-128 0q-18.005333 0-31.018667 11.989333t-13.013333 29.994667l0 171.989333q0 18.005333 13.013333 29.994667t31.018667 11.989333l128 0q18.005333 0 29.994667-11.989333t11.989333-29.994667l0-43.989333-64 0 0 22.016-86.016 0 0-128 86.016 0 0 22.016 64 0zM470.016 470.016l0-43.989333q0-18.005333-13.013333-29.994667t-31.018667-11.989333l-128 0q-18.005333 0-29.994667 11.989333t-11.989333 29.994667l0 171.989333q0 18.005333 11.989333 29.994667t29.994667 11.989333l128 0q18.005333 0 31.018667-11.989333t13.013333-29.994667l0-43.989333-64 0 0 22.016-86.016 0 0-128 86.016 0 0 22.016 64 0zM809.984 169.984q34.005333 0 59.989333 25.984t25.984 59.989333l0 512q0 34.005333-25.984 59.989333t-59.989333 25.984l-596.010667 0q-36.010667 0-61.013333-25.984t-25.002667-59.989333l0-512q0-34.005333 25.002667-59.989333t61.013333-25.984l596.010667 0z",
    "p-id": 3199
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubtitles);
export default __webpack_public_path__ + "static/media/icon-subtitles.9d7134b9866e3373322deff0dde8fbf0.svg";
export { ForwardRef as ReactComponent };